module.exports = __webpack_public_path__ + "img/20231026.422066e7.png";